import { render, staticRenderFns } from "./appDraft.vue?vue&type=template&id=36fdffb5"
import script from "./appDraft.vue?vue&type=script&lang=js"
export * from "./appDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports